import script from "./ingredients-base-section.vue?vue&type=script&setup=true&lang=js"
export * from "./ingredients-base-section.vue?vue&type=script&setup=true&lang=js"

import "./ingredients-base-section.vue?vue&type=style&index=0&id=32ea9238&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-32ea9238"]])

export default __exports__